export const EMPLOYEES_LIST_LOCALE_PATH = 'src.components.employees.employeesList';
export const EMPLOYEES_INFO_LOCALE_PATH = 'src.components.employees.employeeInfo';
export const EMPLOYEES_LOCALE_PATH = 'src.components.employees';
export const EMPLOYEE_DETAILS_LOCALE_PATH = 'src.components.employees.employeeDetails';
export const EMPLOYEE_DETAILS_STATUS_HISTORY_LOCALE_PATH = 'src.components.employees.employeeDetails.statusHistorySection';
export const EMPLOYEE_DETAILS_EMPLOYMENT_SECTION_LOCALE_PATH = 'src.components.employees.employeeDetails.employmentSection';
export const BENCH_PAGE_LOCALE_PATH = 'src.components.employees.benchPage';
export const LEAVES_PAGE_LOCALE_PATH = 'src.components.employees.leavesPage';
export const ONBOARDING_PAGE_LOCALE_PATH = 'src.components.employees.onboardingPage';
export const OFFBOARDING_PAGE_LOCALE_PATH = 'src.components.employees.offboardingPage';
export const CHANGE_REASONS_PAGE_LOCALE_PATH = 'src.components.employees.changeReasonsPage';
export const CONFIGURATION_PAGE_LOCALE_PATH = 'src.components.employees.configurationPage';
export const RISKS_PAGE_LOCALE_PATH = 'src.components.employees.risksPage';
export const ALUMNI_PAGE_LOCALE_PATH = 'src.components.employees.alumniPage';
export const RISK_LEVELS_PAGE_LOCALE_PATH = 'src.components.employees.riskLevelsPage';
export const RISK_REASONS_PAGE_LOCALE_PATH = 'src.components.employees.riskReasonsPage';
export const LIFECYCLE_STAGES_PAGE_LOCALE_PATH = 'src.components.employees.lifecycleStagesPage';
export const EXPECTATIONS_PAGE_LOCALE_PATH = 'src.components.employees.expectationsPage';
export const RESOLUTION_OUTCOMES_PAGE_LOCALE_PATH = 'src.components.employees.resolutionOutcomesPage';
export const RISK_STATUSES_PAGE_LOCALE_PATH = 'src.components.employees.riskStatusesPage';
export const PROJECTS_PAGE_LOCALE_PATH = 'src.components.employees.projectsPage';

